<template>
  <div class="dropdown">
    <button
      class="btn btn-primary d-flex align-items-center gap-2"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <font-awesome-icon icon="chevron-down" />
      {{ t("dashboard.portfolio.footer.action") }}
    </button>
    <ul class="dropdown-menu dropdown-menu-end">
      <li>
        <button
          class="dropdown-item"
          type="button"
          @click="navigateToInventoryTab?.('send')"
        >
          {{ t("common.actions.send") }}
        </button>
      </li>
      <li>
        <button
          class="dropdown-item"
          type="button"
          @click="navigateToInventoryTab?.('cancel')"
        >
          {{ t("common.actions.cancel") }}
        </button>
      </li>
      <li>
        <button
          class="dropdown-item"
          type="button"
          @click="navigateToInventoryTab?.('sell')"
        >
          {{ t("common.actions.sell") }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const navigateToInventoryTab = inject<
  ((action: "send" | "cancel" | "sell") => void) | undefined
>("navigateToInventoryTab", undefined);
</script>

<style scoped lang="scss"></style>
